<template>
  <div class='order-search-admin'>
    <sub-nav :navs='navs' />
    <h2>订单查询</h2>
    <div class='content'>
      <div class='item'>
        <span class='label'>学校：</span>
        <select v-model='selectedSchool' class='select' @change='selectSchool'>
          <option value='-1' disabled>请选择学校</option>
          <option v-for='(item,index) in schoolOptions' :key='index' :value='item.id'>{{ item.name }}</option>
        </select>
      </div>
      <div class='item'>
        <span class='label'>院系：</span>
        <select v-model='selectedCollege' class='select' @change='selectCollege' @focus='focusCollege'>
          <option value='-1' disabled>请选择院系</option>
          <option v-for='(item,index) in collegeOptions' :key='index' :value='item.id'>{{ item.name }}</option>
        </select>
      </div>
      <div class='item'>
        <span class='label'>年级-专业班级：</span>
        <select v-model='selectedCls' class='select' @change='selectCls' @focus='focusCls'>
          <option value='-1' disabled>请选择专业班级</option>
          <option v-for='(item,index) in clsOptions' :key='index' :value='item.id'>{{ item.name }}</option>
        </select>
      </div>
      <div class='item'>
        <span class='label'>姓名：</span>
        <input v-model='name' class='input' type='text' placeholder='请输入'>
      </div>
      <div class='item'>
        <span class='label'>学号：</span>
        <input v-model='student_num' class='input' type='text' placeholder='请输入'>
      </div>
      <div class='item'>
        <span class='label'>批发单号：</span>
        <input v-model='wholesale_no' class='input' type='text' placeholder='请输入批发单号'>
      </div>
      <div class='item'>
        <span class='label'>书号：</span>
        <input v-model='book_no' class='input' type='text' placeholder='请输入书号'>
      </div>
      <div class='item'>
        <span class='label'>订单状态：</span>
        <div class='order-type-wrapper' @click='toggleOrderType("NOT_CONFIRM")'>
          <img v-if='orderType === "NOT_CONFIRM"' src='../assets/imgs/selected_on.png' alt='' class='icon'>
          <img v-else src='../assets/imgs/selected_off.png' alt='' class='icon'>
          <span>待确认</span>
        </div>
        <div class='order-type-wrapper' @click='toggleOrderType("IS_CONFIRM")'>
          <img v-if='orderType === "IS_CONFIRM"' src='../assets/imgs/selected_on.png' alt='' class='icon'>
          <img v-else src='../assets/imgs/selected_off.png' alt='' class='icon'>
          <span>已确认</span>
        </div>
      </div>
      <a href='javascript:;' class='btn btn-search' @click='searchHandler'>查询</a>
      <a href='javascript:;' class='btn btn-back' @click='goBack'>返回</a>
    </div>
  </div>
</template>

<script>
import SubNav from '@/components/SubNav'

import { SCHOOL_LIST, COLLEGE_LIST, CLS_LIST } from '@/api'

export default {
  components: {
    SubNav,
  },
  data() {
    return {
      navs: [{label: '个人中心', path: '/my'}],
      selectedSchool: '-1',
      selectedCollege: '-1',
      selectedCls: '-1',
      schoolOptions: [],
      collegeOptions: [],
      clsOptions: [],
      wholesale_no: '',
      book_no: '',
      name: '',
      student_num: '',
      orderType: 'NOT_CONFIRM'
            
    }
  },
  computed: {
    schoolName() {
      let name = ''
      this.schoolOptions.forEach(e=>{
        if (e.id == this.selectedSchool) {
          name = e.name
        }
      })
      return name
    },
    collegeName() {
      let name = ''
      this.collegeOptions.forEach(e=>{
        if (e.id == this.selectedCollege) {
          name = e.name
        }
      })
      return name
    },
    clsName() {
      let name = ''
      this.clsOptions.forEach(e=>{
        if (e.id == this.selectedCls) {
          name = e.name
        }
      })
      return name
    },
  },
  created() {
    // 获取学校列表
    this.getSchoolList()
    this.setActiveBar('MY')
  },
  methods: {
    // 查询
    searchHandler() {
      let payload = {
        orderType: this.orderType,
        school: this.schoolName,
        department: this.collegeName,
        profession_class: this.clsName,
        name: this.name,
        student_num: this.student_num,
        wholesale_no: this.wholesale_no,
        book_no: this.book_no
      }
      this.$store.commit('setAdminOrderParams',payload)
      this.goRouter('/myorderadmin')

    },

    // 切换订单状态
    toggleOrderType(val) {
      this.orderType = val
    },

    // 监听学院获取焦点事件
    focusCollege() {
      if (this.selectedSchool === '-1') {
        this.$notify('请先选择学校','warning')
      }
    },

    // 监听专业班级获取焦点事件
    focusCls() {
      if ((this.selectedSchool === '-1') || (this.selectedCollege === '-1')) {
        this.$notify('请先选择学校/院系','warning')
      }
    },

    // 获取学校
    getSchoolList() {
      SCHOOL_LIST().then(res=>{
        if (res.data.code === 0) {
          this.schoolOptions = res.data.data
          let payload = {
            type: 'SCHOOL',
            list: res.data.data
          }
          this.$store.commit('setSchoolInfoList',payload)
        }
      })
    },

    // 获取院系
    getCollegeList(para) {
      COLLEGE_LIST(para).then(res=>{
        if (res.data.code === 0) {
          this.collegeOptions = res.data.data
          let payload = {
            type: 'COLLEGE',
            list: res.data.data
          }
          this.$store.commit('setSchoolInfoList',payload)
        }
      })
    },

    // 获取班级
    getClsList(para) {
      CLS_LIST(para).then(res=>{
        if (res.data.code === 0) {
          this.clsOptions = res.data.data
          let payload = {
            type: 'CLS',
            list: res.data.data
          }
          this.$store.commit('setSchoolInfoList',payload)
        }
      })
    },

    // 选择学校 -> 获取院系
    selectSchool(e) {
      let para = {
        school_id: e.target.value
      }
      this.collegeOptions = []
      this.clsOptions = []
      this.getCollegeList(para)
      let payload = {
        type: 'SCHOOL',
        item: e.target.value
      }
      this.$store.commit('setSelectedSchoolInfo',payload)
    },

    // 选择院系 -> 获取专业班级
    selectCollege(e) {
      let para = {
        department_id: e.target.value
      }
      this.clsOptions = []
      this.getClsList(para)
      let payload = {
        type: 'COLLEGE',
        item: e.target.value
      }
      this.$store.commit('setSelectedSchoolInfo',payload)
    },

    // 选择班级
    selectCls(e) {
      let payload = {
        type: 'CLS',
        item: e.target.value
      }
      this.$store.commit('setSelectedSchoolInfo',payload)
    }
  },
    
}
</script>

<style lang="less" scoped>
@import "../assets/css/mixin.less";
.order-search-admin {
  width: 1200px;

  h2 {
    font-size: 20px;
    font-weight: 500;
    text-align: center;
  }
  .content {
    width: 860px;
    height: 650px;
    margin: 30px auto 20px;
    background: @blue-l;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    box-sizing: border-box;
    padding: 30px 0;

    .item {
      width: 100%;
      height: 36px;
      line-height: 36px;
      text-align: center;
      font-size: 16px;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin: 20px 0;

      .label {
        display: inline-block;
        width: 290px;
        text-align: end;
        margin-right: 10px;

        i {
          color: red;
        }
      }

      .select {
        box-sizing: border-box;
        display: inline-block;
        width: 300px;
        height: 34px;
        border: 1px solid #dddddd;
        border-radius: 5px;
        background: #ffffff;
        outline: none;
      }

      .input {
        box-sizing: border-box;
        display: inline-block;
        width: 300px;
        height: 34px;
        outline: none;
        border: 1px solid #dddddd;
        border-radius: 5px;
        text-indent: 5px;
      }

      .order-type-wrapper {
        height: 40px;
        margin-right: 20px;
        width: 80px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
        cursor: pointer;
      }
    }

    a.btn {
      display: block;
      width: 300px;
      height: 38px;
      line-height: 38px;
      margin: 0 auto;
      text-align: center;
      font-size: 20px;
      color: #fff;
      border-radius: 5px;

      &.btn-search {
        background-color: @blue-d;
        margin-top: 50px;
      }

      &.btn-back {
        background-color: #cccccc;
        margin-top: 15px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/OrderSearchAdmin.vue